<template>
    <nav class="level">
        <p class="level-item has-text-centered">
            <router-link to="/mercado" class="link is-info">Mercado</router-link>
        </p>

        <p class="level-item has-text-centered">
            <router-link to="/mercado/baul" class="link is-info">Mi Baúl</router-link>
        </p>

        <p class="level-item has-text-centered">
            <img src="https://bulma.io/images/bulma-type.png" alt="" style="height: 30px;">
        </p>
        <p class="level-item has-text-centered">
            <a class="link is-info">Mis Compras</a>
        </p>
        <p class="level-item has-text-centered">
            <a class="link is-info">Mis Ventas</a>
        </p>
    </nav>
</template>

<script>
export default {
    name:'StoreLevel'
}
</script>

<style>

</style>